import PortOpeningRule from '../../../models/entities/PortOpeningRule';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';

export type PORColumn = {
	header: string;
	cell: (rule: PortOpeningRule) => string;
	limit?: number;
};

const truncateItem = (s: string, maxChars = 25): string =>
	s.length > maxChars ? s.slice(0, maxChars) + '…' : s;

const truncateList = (value: string | undefined, max = 10): string => {
	if (!value) return '';
	const items = value.split(';').map((s) => s.trim()).filter(Boolean);
	const visible = items.slice(0, max).map((s) => truncateItem(s));
	if (items.length <= max) return visible.join('; ');
	return visible.join('; ') + ` ... (+${items.length - max} more)`;
};

export const RuleColumnsLayout = new Map<PortOpeningRequestsDirection, PORColumn[]>();

RuleColumnsLayout.set(PortOpeningRequestsDirection.SubscriptionToOnPrem, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRule) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRule) => truncateList(rule.azureName ? rule.azureName : rule.name, 40),
		limit: 40,
	},
	{
		header: 'Type',
		cell: (rule: PortOpeningRule) => rule.isTemporary.toString() == 'true' ? 'Temporary' : 'Permanent',
	},
	{
		header: 'Being Attested',
		cell: (rule: PortOpeningRule) => rule.isBeingAttested?.toString() == 'true' ? 'Yes' : 'No',
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRule) => rule.action?.name,
	},
	{
		header: 'Region',
		cell: (rule: PortOpeningRule) => rule.region?.name,
	},
	{
		header: 'Dir.',
		cell: (rule: PortOpeningRule) => rule.trafficDirection?.name,
		limit: 15,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRule) => truncateList(rule.sourceIPs, 30),
		limit: 30,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRule) => truncateList(rule.destinationIPs, 30),
		limit: 30,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRule) => rule.destinationPorts,
	},
	{
		header: 'Protocol',
		cell: (rule: PortOpeningRule) => rule.protocol,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRule) => rule.description,
		limit: 20,
	},
]);

RuleColumnsLayout.set(PortOpeningRequestsDirection.SubscriptionToInternet, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRule) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRule) => truncateList(rule.azureName ? rule.azureName : rule.name, 40),
		limit: 40,
	},
	{
		header: 'Type',
		cell: (rule: PortOpeningRule) => rule.isTemporary.toString() == 'true' ? 'Temporary' : 'Permanent',
	},
	{
		header: 'Being Attested',
		cell: (rule: PortOpeningRule) => rule.isBeingAttested?.toString() == 'true' ? 'Yes' : 'No',
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRule) => rule.action?.name,
	},
	{
		header: 'Region',
		cell: (rule: PortOpeningRule) => rule.region?.name,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRule) => truncateList(rule.sourceIPs, 15),
		limit: 15,
	},
	{
		header: 'Dest. URLs',
		cell: (rule: PortOpeningRule) => rule.destinationURLs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRule) => truncateList(rule.destinationIPs, 15),
		limit: 15,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRule) => rule.destinationPorts,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRule) => rule.description,
		limit: 20,
	},
]);